import { Component, Input, OnInit } from "@angular/core";
import { Customer } from "../../../../shared/models/customer";
import { CustomerTenant } from "../../../../shared/models/customer-tenant";
import { getApp } from "../app";

@Component({
  selector: "app-customer-entra-card",
  templateUrl: "./customer-entra-card.component.html",
  styleUrls: ["./customer-entra-card.component.scss"],
})
export class CustomerEntraCardComponent implements OnInit {
  customer: Customer = new Customer();

  app = getApp((app) => {
    this.app = app;
  });

  async ngOnInit() {
    let customerDetails = await this.app.auth.entraCustomerDetails(
      this.app.customers.expectCurrent
    );

    if (customerDetails != null) {
      this.customer = customerDetails;
    }
  }

  get linkedTenant(): CustomerTenant | null {
    return (
      this.customer.tenants?.find(
        (t) => t.provider === "entra" && t.adminConsent
      ) ?? null
    );
  }

  async startAdminConsent(): Promise<void> {
    let returnUrl = `${this.app.environment.baseUrl}/${this.customer.code}/users`;

    if (this.customer.id) {
      var result = await this.app.auth.entraAdminConsent(
        this.customer.id,
        returnUrl
      );

      window.location.href = result.returnUrl;
    }
  }

  toggleEntraBenefits(): void {
    this.app.auth.entraBenefitsOpen = !this.app.auth.entraBenefitsOpen;
  }
}
